window.observeElementOffscreen = function(elementId, dotNetRef, methodName) {
    const el = document.getElementById(elementId);
    if (!el) {
        return;
    }
    if (!window._offscreenObservers) window._offscreenObservers = {};
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                // Call the specified .NET method with isOffscreen and elementId
                dotNetRef.invokeMethodAsync(methodName, !entry.isIntersecting, elementId);
            });
        },
        { root: null, threshold: 0 }
    );
    observer.observe(el);
    window._offscreenObservers[elementId] = observer;
};

window.unobserveElementOffscreen = function(elementId) {
    if (window._offscreenObservers && window._offscreenObservers[elementId]) {
        window._offscreenObservers[elementId].disconnect();
        delete window._offscreenObservers[elementId];
    }
};
